import type { AdminProfile } from "@/core/types";
import { adminRequestsTyped } from "@/api/(requests)/adminTyped";

export async function getAdminProfile(): Promise<AdminProfile> {
  return adminRequestsTyped.fetch_admin_profile();
}
